import script from "./NuovaRilevazione.vue?vue&type=script&setup=true&lang=js"
export * from "./NuovaRilevazione.vue?vue&type=script&setup=true&lang=js"

import "./NuovaRilevazione.vue?vue&type=style&index=0&id=bda5ef32&lang=scss&scoped=true"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bda5ef32"]])

export default __exports__